/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import styles from './TabPrivateInfo.module.scss';
import {BaechaList2TableItem} from "../../../BaechaList2.interface";
import {Table} from "antd";

interface TabPrivateInfoProps {
	data: BaechaList2TableItem;
}

const TabPrivateInfo = ({data}: TabPrivateInfoProps) => {
	const dataSource = [
		{
			key: 'address',
			label: '현장 주소',
			value: data.privateAddress,
		},
		{
			key: 'phone',
			label: '현장 연락처',
			value: data.privatePhoneNum,
		},
		{
			key: 'note',
			label: '기타',
			value: data.privateNote,
		},
	];

	const columns = [
		{
			title: '내용',
			dataIndex: 'label',
			key: 'label',
			width: 120,
		},
		{
			title: '값',
			dataIndex: 'value',
			key: 'value',
		},
	];

	return (
		<div className={styles.wrap}>
			<Table
				bordered
				size='small'
				style={{ tableLayout: 'fixed', width: '100%' }}
				scroll={{ x: 'max-content' }}
				pagination={false}
				dataSource={dataSource}
				columns={columns}
			/>
		</div>
	);
};

export default TabPrivateInfo;
